import { FunctionComponent } from "react";
import { StyledContent, StyledLabel, StyleValuePair } from "./valuepair.styles";
import Copy from "./copy";

interface ValuePairProps {
  label: string;
  children: any;
  copy?: boolean;
}

const ValuePair: FunctionComponent<ValuePairProps> = ({
  label,
  children,
  copy = false,
}) => {
  return (
    <StyleValuePair>
      <StyledLabel>{label}</StyledLabel>
      <StyledContent>
        {children}
        {copy && typeof children === "string" && <Copy value={children} />}
      </StyledContent>
    </StyleValuePair>
  );
};

export default ValuePair;
